import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { useDeleteImage } from '@Domains/UploadImage';
import { InputLabel } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { getFileNameByUrl } from '../utils';

type UseSameFileCheckboxProps = {
  name: string;
  index: number;
  disabledTh?: boolean;
  disabledEn?: boolean;
  assets: Array<{
    fileNameTh?: string;
    fileNameEn?: string;
    urlTh?: string;
    urlEn?: string;
  }>;
};

const UseSameFileCheckbox: React.FC<UseSameFileCheckboxProps> = ({
  name,
  index,
  disabledTh,
  disabledEn,
  assets,
}) => {
  const { id } = useParams();
  const { setValue, trigger } = useFormContext();
  const { deleteImage } = useDeleteImage(Number(id));

  const handleChangeAsset = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;

    if (isChecked) {
      const fileNameEn = getFileNameByUrl(assets[index]?.urlEn || '');
      const sectionName = name;

      deleteImage(sectionName, fileNameEn);

      setValue(
        `${name}.assets.${index}.fileNameEn`,
        assets[index]?.fileNameTh || ''
      );
      setValue(`${name}.assets.${index}.descriptionEn`, '');
      setValue(`${name}.assets.${index}.urlEn`, null);
    } else {
      setValue(`${name}.assets.${index}.fileNameEn`, '');
      setValue(`${name}.assets.${index}.urlEn`, '');
    }

    trigger(`${name}.assets.${index}.fileNameTh`);
    trigger(`${name}.assets.${index}.fileNameEn`);
  };

  return (
    <Flex alignItems="baseline" gap={3}>
      <InputLabel sx={{ width: 1, maxWidth: 350, textAlign: 'right' }}>
        การอัปโหลดภาพสำหรับภาษาอังกฤษ
      </InputLabel>
      <FormCheckbox
        name={`${name}.assets.${index}.isUseSameFile`}
        label="ใช้ภาพเดียวกับภาษาไทย"
        onChange={handleChangeAsset}
        mt={1}
        width={1}
        inputProps={{ disabled: disabledEn || disabledTh }}
        sx={{ width: '100%', maxWidth: '340px' }}
      />
    </Flex>
  );
};

export default UseSameFileCheckbox;
